<template>
    <div class="stap-header lichtblauwbg width100">
        <div class="fontsize14 bold midblauw padding10 uppercase">
            Stap {{ step }}: {{ title }}
        </div>
    </div>
</template>

<script>
export default {
    name: 'CardHeader',
    props: {
        step: String,
        title: String,
    },
}
</script>
